/**
 * バイト数を人間可読な短い文字列にする（#764）。
 *
 * サーバ側の `gennai.core.utils.format_size` と**同じ表記**にしてある。
 * プレビュー時（フロントが表示）と公開完了時（サーバが返す文言）で桁の丸め方が
 * 違うと、同じ作品なのに違う数字に見える。
 */
export function formatSize(bytes: number): string {
  const MIB = 1024 * 1024
  if (bytes >= MIB) return `${(bytes / MIB).toFixed(1)}MB`
  if (bytes >= 1024) return `${Math.round(bytes / 1024)}KB`
  return `${Math.round(bytes)}B`
}

/**
 * 「この作品の大きさ: 約 28MB」の 1 行。サイズが不明なら null。
 *
 * `truncated` は GitHub の Trees API が巨大リポで結果を打ち切ったケース。
 * そのとき合計は**下限**でしかないので、断定しない言い方にする。
 */
export function sizeLabel(bytes?: number | null, truncated = false): string | null {
  if (bytes === undefined || bytes === null) return null
  return truncated ? `${formatSize(bytes)} 以上` : formatSize(bytes)
}
